import { makeStyles } from '@mui/styles'
import React from 'react'
import { Grid, Typography, Tooltip, Box } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '14px',
    maxWidth: 300
  }
}))

export const StepReturnQualityFooterInfo: React.FC = () => {
  const classes = useStyles()

  return (
    <Grid container spacing={0}>
      <Grid item md={2}></Grid>
      {/* En Perfecto Estado */}
      <Grid item xs={12} sm={6} md={2}>
        <Tooltip
          classes={{
            tooltip: classes.tooltip
          }}
          title={
            <span>
              Producto apto para venta.
              <br />
              Se debe continuar el proceso desde Put Away para finalizar la
              devolución.
            </span>
          }
          arrow
          placement='top'
        >
          <Box display='flex' alignItems='center' style={{ cursor: 'pointer' }}>
            <InfoOutlinedIcon
              color='action'
              fontSize='medium'
              style={{ marginRight: '8px', color: '#FF9800' }}
            />
            <Typography variant='body1' component='span'>
              En Perfecto estado
            </Typography>
          </Box>
        </Tooltip>
      </Grid>

      {/* Rechazo comercial */}
      <Grid item xs={12} sm={6} md={2}>
        <Tooltip
          classes={{
            tooltip: classes.tooltip
          }}
          title={
            <span>
              Producto con observación.
              <br />
              Diríjase al módulo de Alertas de Inventario.
            </span>
          }
          arrow
          placement='top'
        >
          <Box display='flex' alignItems='center' style={{ cursor: 'pointer' }}>
            <InfoOutlinedIcon
              color='action'
              fontSize='medium'
              style={{ marginRight: '8px', color: '#FF9800' }}
            />
            <Typography variant='body1' component='span'>
              Rechazo comercial
            </Typography>
          </Box>
        </Tooltip>
      </Grid>

      {/* Enviar a calidad */}
      <Grid item xs={12} sm={6} md={2}>
        <Tooltip
          classes={{
            tooltip: classes.tooltip
          }}
          title={
            <span>
              Producto con observación.
              <br />
              Diríjase al módulo de Alertas de Inventario.
            </span>
          }
          arrow
          placement='top'
        >
          <Box display='flex' alignItems='center' style={{ cursor: 'pointer' }}>
            <InfoOutlinedIcon
              color='action'
              fontSize='medium'
              style={{ marginRight: '8px', color: '#FF9800' }}
            />
            <Typography variant='body1' component='span'>
              Enviar a calidad
            </Typography>
          </Box>
        </Tooltip>
      </Grid>

      {/* Faltante */}
      <Grid item xs={12} sm={6} md={2}>
        <Tooltip
          classes={{
            tooltip: classes.tooltip
          }}
          title={
            <span>
              Producto no encontrado.
              <br />
              Se enviarán a ubicación de diferencia.
            </span>
          }
          arrow
          placement='top'
        >
          <Box display='flex' alignItems='center' style={{ cursor: 'pointer' }}>
            <InfoOutlinedIcon
              color='action'
              fontSize='medium'
              style={{ marginRight: '8px', color: '#FF9800' }}
            />
            <Typography variant='body1' component='span'>
              Faltante
            </Typography>
          </Box>
        </Tooltip>
      </Grid>

      <Grid item md={2}></Grid>
    </Grid>
  )
}
